import moment from "moment";

const Helper = {
  getRecentData: (data) => {
    var mostRecentDate = moment(
      Math.max.apply(
        null,
        data.map((e) => {
          return moment(e.dt);
        })
      )
    ).format("YYYY-MM-DD");

    return mostRecentDate;
  },

  tableData: (orgPortfolio, iqcioPortfolio) => {
    // original portfolio, iqcio portfolio
    // each data of type array of objects. keys country,model,total
    if (!orgPortfolio || !iqcioPortfolio) {
      return;
    }
    let tableData = [];
    if (orgPortfolio.length > 0 && iqcioPortfolio.length) {
      for (let i = 0; i < orgPortfolio.length; i++) {
        let x = [];

        x[0] = orgPortfolio[i].Country + " - " + orgPortfolio[i].Model;
        x[1] = orgPortfolio[i].Total;
        x[2] = "-";
        x[3] = "-";

        if (orgPortfolio[i].Model.toUpperCase() === "CASH") {
          x[4] = "";
          x[5] = "";
        } else {
          // common data filter from iqcio portfolio
          let filtered = iqcioPortfolio.filter(
            (e) => e.Model == orgPortfolio[i].Model
          );

          if (filtered.length > 0) {
            // your portfolio subtract iqcio portfolio
            let originalAllocation = orgPortfolio[i]["Total"] * 1;
            let iqcioAllocation = filtered[0]["Total"] * 1;

            let val = originalAllocation - iqcioAllocation;
            x[2] = filtered[0].Country + " - " + filtered[0].Model;
            x[3] = filtered[0].Total;

            // iqcio portfolio greater than original portfolio then buy
            if (val > 0) {
              //positive
              x[4] = "reduce";
              x[5] = 100 - val;
            } else if (val == 0) {
              x[4] = "hold";
              x[5] = val;
            } else {
              //negative
              x[4] = "increase";
              x[5] = Math.abs(val);
            }
          } else {
            x[4] = "sell";
            x[5] = 100;
          }
        }
        tableData.push(x);
      }

      for (let i = 0; i < iqcioPortfolio.length; i++) {
        let x = [];
        let filtered = [];
        if (
          iqcioPortfolio &&
          iqcioPortfolio.length > 0 &&
          orgPortfolio &&
          orgPortfolio.length > 0
        ) {
          let d1Model = orgPortfolio.filter(
            (e) => e["Model"] == iqcioPortfolio[i]["Model"]
          );

          if (d1Model.length > 0) {
            try {
              filtered = iqcioPortfolio.filter(
                (e) => e.Model == d1Model[0]["Model"]
              );
            } catch (err) {
              console.log(err);
              filtered = [];
            }
          } else {
            filtered = [];
          }
        }
        if (
          filtered.length === 0 &&
          iqcioPortfolio[i].Country.toUpperCase() !== "CASH"
        ) {
          x[0] = "-";
          x[1] = "-";
          x[2] = iqcioPortfolio[i].Country + " - " + iqcioPortfolio[i].Model;
          x[3] = iqcioPortfolio[i].Total;

          x[4] = "buy";
          x[5] = iqcioPortfolio[i].Total;

          tableData.push(x);
        } else {
          continue;
        }
      }
    } // op array of arrays
    return tableData;
  },
  // tableData: (orgPortfolio, data2) => {
  //   let tableData = [];

  //   for (let i = 0; i < data1.length; i++) {
  //     let x = [];

  //     x[0] = data1[i].fund_name;
  //     x[1] = data1[i].allocation;
  //     x[2] = "-";
  //     x[3] = "-";

  //     if (data1[i].fund_name.toUpperCase() === "CASH") {
  //       x[4] = "";
  //       x[5] = "";
  //     } else {
  //       x[4] = "sell";
  //       x[5] = data1[i].allocation;
  //     }
  //     tableData.push(x);
  //   }
  //   for (let i = 0; i < data2.length; i++) {
  //     let d1 = data1.filter(
  //       (e) => e.fund_name.toUpperCase() == data2[i].fund_name.toUpperCase()
  //     );
  //     if (d1.length > 0) {
  //       let index;

  //       for (let a = 0; a < tableData.length; a++) {
  //         let ar = tableData[a];
  //         if (ar[0].toUpperCase() == d1[0].fund_name.toUpperCase()) {
  //           console.log(a);

  //           ar[2] = data2[i].fund_name;
  //           ar[3] = data2[i].allocation;

  //           if (ar[0].toUpperCase() !== "CASH") {
  //             ar[4] = ar[1] * 1 - data2[i]["allocation"] > 0 ? "buy" : "sell";
  //             ar[5] = Math.abs(ar[1] * 1 - data2[i]["allocation"]);
  //           }
  //         }
  //       }
  //     } else {
  //       let x = [];

  //       x[0] = "-";
  //       x[1] = "-";
  //       x[2] = data2[i].fund_name;
  //       x[3] = data2[i].allocation;

  //       if (data2[i].fund_name.toUpperCase() === "CASH") {
  //         x[4] = "";
  //         x[5] = "";
  //       } else {
  //         x[4] = "buy";
  //         x[5] = data2[i].allocation;
  //       }
  //       tableData.push(x);
  //     }
  //   }
  //   return tableData;
  // },
};

export default Helper;



// WEBPACK FOOTER //
// ./src/components/pages/helper.current_buy_sell.js